import { OldOnboarding } from "./onboardingVersions";
import { DcgAutomation } from "./onboardingVersions";

export const landingPageList = [
    OldOnboarding.toLowerCase(),
    DcgAutomation.toLowerCase(),
    "subscriptionconfirmation",
    "processing",
    "invite",
    "bootstrapdemo"
];

export const isLandingPage = (url) =>
    landingPageList.some(landingPageKeyword => url.includes(landingPageKeyword));

export const requiresAuthLandingPageList = [
    "processinvite"
];

export const isRequiresAuthLandingPage = (url) =>
    requiresAuthLandingPageList.some(landingPageKeyword => url.includes(landingPageKeyword));
